import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { TreeView as MuiTreeView, } from "@mui/x-tree-view/TreeView";
import equal from "fast-deep-equal";
import { TreeItem as MuiTreeItem, } from "@mui/x-tree-view/TreeItem";
import TreeItem from "./TreeItem";
const LAZY_LOAD__PLACEHOLDER = "_lazy_load_placeholder";
const TreeView = ({ treeData, lazyLoadFn, treeItemClasses, titleRender, ContentComponent, expanded: expandedProp, onNodeToggle: onNodeToggleProp, defaultCollapseIcon, defaultExpandIcon, ...treeProps }) => {
    const [expanded, setExpanded] = useState(expandedProp ? [...expandedProp] : []);
    useEffect(() => {
        if (expandedProp) {
            if (!equal(expandedProp, expanded)) {
                setExpanded(expandedProp);
            }
        }
    }, [expandedProp]);
    const handleToggle = (event, nodeIds) => {
        setExpanded(nodeIds);
        onNodeToggleProp && onNodeToggleProp(null, nodeIds);
    };
    const handleExpand = (key) => {
        const newExpanded = [...expanded, key];
        setExpanded(newExpanded);
        onNodeToggleProp && onNodeToggleProp(null, newExpanded);
    };
    const renderChildren = (parent, children) => {
        const hasLazyLoad = typeof children != "undefined" && children.length == 0;
        if (hasLazyLoad && parent) {
            return (_jsx(MuiTreeItem, { nodeId: parent.key + LAZY_LOAD__PLACEHOLDER }));
        }
        if (!children) {
            return null;
        }
        return children.map((node) => {
            return (_jsx(TreeItem, { node: node, collapseIcon: defaultCollapseIcon, expandIcon: defaultExpandIcon, ContentComponent: ContentComponent, treeItemClasses: treeItemClasses, onExpand: handleExpand, titleRender: titleRender, lazyLoadFn: lazyLoadFn, renderChildren: renderChildren }, node.key));
        });
    };
    return (_jsx(MuiTreeView, { expanded: expanded, onNodeToggle: handleToggle, ...treeProps, children: treeData && renderChildren(null, treeData) }));
};
export default TreeView;
